// API Configuration
const config = {
  API_BASE_URL:
    import.meta.env.VITE_API_URL ||
    "https://klzzhk0t9a.execute-api.us-east-1.amazonaws.com/cauto-backend",
  ENVIRONMENT: import.meta.env.NODE_ENV || "development",
};

// Input validation utilities
const validateId = (id) => {
  if (!id || typeof id !== "string" || id.trim() === "") {
    throw new Error("Invalid ID parameter");
  }
  // Prevent path traversal attacks
  if (id.includes("..") || id.includes("/") || id.includes("\\")) {
    throw new Error("Invalid ID format");
  }
  return id.trim();
};

// API Endpoints
export const API_ENDPOINTS = {
  ACCOUNTS: {
    LIST: "/functions/account-information-summary",
    UPDATE: (id) => `/functions/update-account/${validateId(id)}`,
    DELETE: (id) => `/functions/delete-account/${validateId(id)}`,
    DETAILS: (id) => `/functions/account-details/${validateId(id)}`,
    OPCO: "/functions/list-management-information/opco",
    TYPES: "/functions/list-management-information/types",
    DOMAINS: "/functions/list-management-information/domain",
    ORGANIZATIONS: "/functions/list-management-information/organizations",
    CONTACTS: "/functions/list-management-information/contacts",
    COST_CENTER: "/functions/list-management-information/cost-center",
    GROUPS: "/functions/list-management-information/groups",
  },
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
  },
  REPORTS: {
    GENERATE: "/functions/generate-report",
    DOWNLOAD: (id) => `/functions/reports/${validateId(id)}/download`,
  },
  AWS: {
    CREATE_ACCOUNT: "/functions/create-account/aws",
    RUN_POWERSHELL_SCRIPT: "/functions/run-ps",
    RUN_METHOD: "/functions/run",
    EXECUTION_RESULTS: "/functions/results",
    SEARCH_AD_USERS: "/functions/list-from-db/aws/ad",
    S3: "/functions/reports/aws-s3",
    EC2: "/functions/reports/aws-ec2-instances",
    IAM_USERS: "/functions/reports/aws-iam-users",
    AD_USERS: "/functions/reports/aws-ad-users",
    AD_GROUPS: "/functions/reports/aws-ad-groups",
    RDS: "/functions/reports/aws-rds",
    EFS: "/functions/reports/aws-efs",
    ACCOUNTS: "/functions/reports/aws-accounts",
    MONTHLY_COSTS: "/functions/reports/aws-monthly-costs",
    QUICKSIGHT: "/functions/reports/quicksight"
  },
};

// API Configuration
export const API_CONFIG = {
  BASE_URL: config.API_BASE_URL,
  TIMEOUT: 20000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// Environment configuration
export const ENV_CONFIG = {
  IS_DEVELOPMENT: config.ENVIRONMENT === "development",
  IS_PRODUCTION: config.ENVIRONMENT === "production",
  ENVIRONMENT: config.ENVIRONMENT,
};

// API Configuration utilities
export const getApiConfig = () => {
  const apiKey = import.meta.env.VITE_API_KEY;
  if (!apiKey && config.ENVIRONMENT === "production") {
    throw new Error("API key is required in production environment");
  }
  return { apiKey, baseURL: config.API_BASE_URL };
};

export const getBaseURL = () => config.API_BASE_URL;
